import React, { useCallback, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Divider, Popover, Spin, Tooltip } from "antd";
import {
  getBundleAssignments,
  getBundleDetails,
  getBundlePrimaryHistory,
  getBundlePurchaseHistory,
  getCustomerBundles,
  removeCustomerBlacklist,
  updateCustomerBundle,
} from "utils/api";
import { BUNDLE_TABS, BUNDLE_TABS_OPTIONS } from "pages/customer-management/customerDetails/constants";
import classnames from "classnames";
import CustomButton from "components/Common/buttons/CustomButton";
import starIcon from "assets/images/svg/Star.svg";
import { customDateFormatWithTime, statusFormatterWithMap, textFormatter } from "components/Common/formatter";
import NGIDropdownButton from "components/Common/buttons/NGIDropdownButton";
import menuIcon from "assets/images/svg/MenuVertical.svg";
import starEmptyIcon from "assets/images/svg/Star-empty.svg";
import { USER_ROLES } from "utils/constants";
import infoIcon from "assets/images/svg/InfoBlack.svg";
import removeIcon from "assets/images/svg/remove-customers.svg";
import { TYPES_MAP } from "pages/price-management/Bundles/variables";
import time from "assets/images/svg/Time Span.svg";
import cylinder from "assets/images/svg/Gas Bottle.svg";
import price from "assets/images/svg/Price Tag.svg";
import duration from "assets/images/svg/Timesheet.svg";
import timesheet from "assets/images/svg/Date To.svg";
import circledPlayIcon from "assets/images/svg/Circled Play.svg";
import { extractPromisesResult } from "utils/helpers/functions";
import moment from "moment";
import {
  BUNDLE_ASSIGNMENT_ACTIONS,
  ICONS_MAP,
  STATUS_COLOR_MAP_ASSIGNMENTS,
} from "pages/price-management/Bundles/bundleDetails/constants";
import { Link } from "react-router-dom";
import AssignBundleModal from "pages/customer-management/customerDetails/Tabs/AssignBundleModal";
import { defaultNgiErrorMethod, successMessage } from "components/Common/responses/message";
import ConfirmationModal from "components/Common/modals/ConfirmationModal";
import blacklisted from "assets/images/svg/NoEntry.svg";
import CustomLink from "components/Common/buttons/CustomLink";
import { useSelector } from "react-redux";
import { DictionariesSelector } from "store/dictionaries/selectors";
import ReviewAssignmentModal from "pages/price-management/Bundles/bundleDetails/ReviewAssignmentModal";
import { STATUSES } from "pages/customer-management/customerDetails/constants";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  tabsContainer: {
    display: "flex",
    borderBottom: "1px solid #0000001A",
    padding: "15px 20px",
    margin: -20,
    justifyContent: "space-between",
  },
  tabItem: {
    display: "flex",
    cursor: "pointer",
    position: "relative",

    "&> img": {
      width: 24,
      marginRight: 10,
    },
  },
  active: {
    fontWeight: 700,

    "&:after": {
      content: "''",
      width: "100%",
      height: 3,
      position: "absolute",
      bottom: -17,
      left: 7,
      backgroundColor: "#000000",
    },
  },
  tabDataContainer: {
    marginTop: 40,
  },
  tabName: {},
  tabTitle: {
    fontSize: 13,
    color: "#444444",
  },
  subTitle: {
    color: "#8C8C8C",
    fontSize: 9,
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  headerContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    fontSize: 16,

    "&>div": {
      fontSize: 11,
      fontWeight: 300,
      color: "#8C8C8C",
    },
  },
  bundleInUse: {},
  availableBundles: {},

  noData: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  bundleList: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    marginTop: 15,
  },
  bundleListInUse: {
    gap: 0,
  },
  dataItem: {
    display: "flex",
    flexDirection: "row",
    border: "1px solid #0000001A",
    borderRadius: 5,
  },
  filled: {
    backgroundColor: "#0000000A",
    height: 45,
  },
  infoContainer: {
    display: "flex",
    padding: 20,
    flex: 2,
  },
  name: {
    fontWeight: 600,
    flex: 1,

    "&>img": {
      marginLeft: 5,
      marginTop: -2,
    },
  },
  dataContainer: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    borderTop: "none",
    borderBottom: "none",
    fontWeight: 500,
  },
  assignedToName: {
    fontWeight: 600,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    textDecoration: "underline",

    "&:hover": {
      cursor: "pointer",
      opacity: 0.6,
    },
  },
  category: {
    display: "flex",
    alignItems: "center",
    fontWeight: 500,
    flex: 1,
  },
  actionsContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderLeft: "1px solid #0000001A",
  },
  assignBtn: {
    fontWeight: 500,
    border: "1px dashed #0000004D",
    backgroundColor: "#f0f0f0",
    padding: "5px 20px",
    borderRadius: 3,
    textAlign: "center",
    width: "100%",

    "&:hover": {
      cursor: "pointer",
      opacity: 0.6,
    },
  },
  leftContainer: {
    display: "flex",
    flex: 2,
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 10px",
  },
  section: {
    display: "flex",
    alignItems: "center",
    flexGrow: 0.3,
    justifyContent: "flex-end",

    "& img": {
      width: 30,
      marginRight: -5,
    },
  },
  title: {
    color: "#666666",
    fontSize: 13,
    fontWeight: 300,

    "&>img": {
      height: 16,
    },
  },
  data: {
    fontSize: 13,
    fontWeight: 600,
    marginLeft: 5,
  },
  bundleName: {
    display: "flex",
    fontWeight: 600,
    width: "30%",

    "&>img": {
      width: 12,
      marginLeft: 5,
      marginTop: -2,
    },
  },
  sectionTitle: {
    color: "#777777",
    fontWeight: 400,
    fontSize: 11,
    marginTop: 10,

    "&>img": {
      marginRight: 4,
      marginTop: -2,
    },
  },
  inUseTitle: {
    color: "#17C347",
  },
  inUseItem: {
    backgroundColor: "#17C34712",
    border: "none",
    borderBottom: "1px solid #0000001A",
    borderRadius: "5px 5px 0px 0",
  },
  inUseSubData: {
    display: "flex",
    justifyContent: "end",
    backgroundColor: "#17C34712",
    borderRadius: "0 0 5px 5px",
    padding: 10,
  },
  flex1: {
    flex: 1,
  },
  purchaseTime: {
    backgroundColor: "#0085FF",
    borderRadius: 3,
    fontSize: 11,
    fontWeight: 500,
    color: "#FFF",
    padding: "0px 8px",
    alignItems: "center",
    display: "flex",
    marginRight: 8,
  },

  item: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },
  purchaseName: {
    fontSize: 14,
    fontWeight: 600,
    display: "flex",
    whiteSpace: "break-spaces",
    alignItems: "center",

    "& span": {
      color: "#00000080",
    },
  },
  date: {
    fontSize: 13,
    fontWeight: 600,
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 5,
    marginRight: 10,
    width: 36,
    height: 36,

    "& img": {
      width: 16,
    },
  },
  SetasPrimary: {
    backgroundColor: "#0085FF14",
  },
  RemovePrimary: {
    backgroundColor: "#0000000F",
  },
  "Re-assign": {
    backgroundColor: "#0085FF14",
  },
  "Un-assign": {
    backgroundColor: "#0000000F",
  },
  Assign: {
    backgroundColor: "#0085FF14",
  },
  link: {
    color: "#0085FF",
  },
  detailsList: {},
  listItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },
  detailsTitle: {
    fontWeight: 300,
    fontSize: 13,
  },
  detailsData: {
    fontSize: 13,
    fontWeight: 600,
  },
  buttonsContainer: {
    display: "flex",
  },
  blacklistedContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    border: "1px solid #FF000059",
    borderRadius: 3,
    padding: "5px 10px",
    marginRight: 10,
    width: 220,
  },
  blacklistedTitle: {
    fontSize: 13,
    fontWeight: 600,
    color: "#000000",
  },
  disabled: {
    opacity: 0.6,
    pointerEvents: "none",
  },
  viewAll: {
    color: "#0085FF",
    border: "1px solid #0085FF",
    borderRadius: 3,
    padding: "5px 10px",
    fontSize: 11,

    "&:hover": {
      cursor: "pointer",
      opacity: 0.6,
    },
  },
  pendingActionsContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 20px",
  },
  dataPreview: {
    color: "#000000",
    padding: 15,
    width: 200,
    maxHeight: 200,
    overflow: "auto",
  },
});

const BundlesTab = ({ customer, consumptionStat, isBlacklisted, setIsBlacklisted }) => {
  const classes = useStyles();
  const [isLoading, setLoader] = useState(false);
  const [data, setData] = useState({
    activeList: [],
    pendingList: [],
    purchaseHistory: [],
    primaryHistory: [],
    inUse: null,
  });
  const [activeTab, setActiveTab] = useState(BUNDLE_TABS.LIST);
  const [showAssignBundle, setShowAssignBundle] = useState(false);
  const [removeConfirmation, setRemoveConfirmation] = useState(false);
  const openModal = useCallback(() => setShowAssignBundle(true), []);
  const closeModal = useCallback(() => setShowAssignBundle(false), []);
  const [saveItem, setSaveItem] = useState(null);
  const [previewData, setPreviewData] = useState(null);

  const {
    list: { blacklistRemovingReason },
  } = useSelector(DictionariesSelector);

  const updateData = useCallback((id, action) => {
    setLoader(true);

    updateCustomerBundle({ action }, id)
      .then(() => {
        successMessage(`${action} successfully`);
        getData();
        setLoader(false);
      })
      .catch(err => {
        setLoader(false);
        defaultNgiErrorMethod(err);
      });
  }, []);

  const closeConfirmationModal = useCallback(() => setSaveItem(null), []);
  const onConfirm = useCallback(() => updateData(saveItem.id, saveItem.type), [saveItem]);

  const getData = useCallback(() => {
    setLoader(true);
    Promise.allSettled([
      getCustomerBundles(customer.id),
      getBundleAssignments(customer.id, "customerId", { pageSize: 1000 }),
      getBundlePurchaseHistory(customer.id),
      getBundlePrimaryHistory(customer.id),
      consumptionStat?.bundleId && getBundleDetails(consumptionStat?.bundleId),
    ])
      .then(data => {
        const [customerBundles, customerBundleAssignments, purchaseHistory, primaryHistory, bundleDetails] =
          extractPromisesResult(data);
        setLoader(false);
        setData({
          activeList: customerBundles?.data?.result?.items || [],
          pendingList: customerBundleAssignments?.data?.result?.items || [],
          purchaseHistory: purchaseHistory?.data?.result?.items || [],
          primaryHistory: primaryHistory?.data?.result?.items || [],
          inUse: bundleDetails?.data?.result,
        });
      })
      .catch(() => {
        setLoader(false);
      });
  }, [customer, consumptionStat]);

  useEffect(() => {
    getData();
  }, []);

  const onTabClick = useCallback(e => {
    const tab = e.currentTarget.dataset.tab;
    setActiveTab(tab);
  }, []);

  const removeModalOpen = useCallback(() => setRemoveConfirmation(true), []);
  const removeModalClose = useCallback(() => setRemoveConfirmation(false), []);

  const handleRemove = useCallback(
    (comment, reason) => {
      setLoader(true);
      removeCustomerBlacklist({
        customerId: customer.id,
        removeReason: reason,
        ...(comment ? { comments: comment } : {}),
      })
        .then(() => {
          successMessage("Customer was removed from the blacklist successfully");
          setLoader(false);
          setIsBlacklisted(false);
          removeModalClose();
        })
        .catch(e => {
          setLoader(false);
          defaultNgiErrorMethod(e);
        });
    },
    [customer]
  );

  const getContent = useCallback(
    item => (
      <div className={classes.detailsList}>
        <div className={classes.listItem}>
          <div className={classes.detailsTitle}>Type</div>
          <div className={classes.detailsData}>{TYPES_MAP[item.bundleType]}</div>
        </div>
        <div className={classes.listItem}>
          <div className={classes.detailsTitle}>Cooking Time</div>
          <div className={classes.detailsData}>{item.bundleType === "TB" ? item.cookingTime : item.gasLimit}</div>
        </div>
        <div className={classes.listItem}>
          <div className={classes.detailsTitle}>Bundle Price</div>
          <div className={classes.detailsData}>{item.price}</div>
        </div>
        <div className={classes.listItem}>
          <div className={classes.detailsTitle}>Duration Period</div>
          <div className={classes.detailsData}>{item.validityPeriod}</div>
        </div>
        <div className={classes.listItem}>
          <div className={classes.detailsTitle}>Bundle Start Date</div>
          <div className={classes.detailsData}>{item.activationDate}</div>
        </div>
        <div className={classes.listItem}>
          <div className={classes.detailsTitle}>Bundle End Date</div>
          <div className={classes.detailsData}>{item.deactivationDate}</div>
        </div>
      </div>
    ),
    []
  );

  const getName = useCallback(item => {
    switch (item.type) {
      case "CustomerGroup":
        return `${item.customerGroupName}`;

      default:
        return `${item.type} Assignment`;
    }
  }, []);

  const openPreview = useCallback(item => setPreviewData(item), []);
  const closePreview = useCallback(() => setPreviewData(null), []);

  return (
    <div className={classes.root}>
      <Spin spinning={isLoading}>
        <div className={classes.tabsContainer}>
          {BUNDLE_TABS_OPTIONS.map(tab => (
            <div
              key={tab.key}
              className={classnames(classes.tabItem, activeTab === tab.key && classes.active)}
              data-tab={tab.key}
              onClick={onTabClick}
            >
              <img src={tab.icon} alt={tab.title} />
              <div className={classes.tabName}>
                <div className={classes.tabTitle}>{tab.title}</div>
                <div className={classes.subTitle}>{tab.subTitle}</div>
              </div>
            </div>
          ))}
        </div>
        <div className={classes.tabDataContainer}>
          {activeTab === BUNDLE_TABS.LIST && (
            <div>
              <div className={classes.actions}>
                <div className={classes.headerContainer}>
                  Bundles
                  <div>All available bundles for the customer. You can add new bundles any time.</div>
                </div>
                {customer && customer?.status !== STATUSES.REPOSSESSED && customer?.status !== STATUSES.SUSPENDED && (
                  <div className={classes.buttonsContainer}>
                    {isBlacklisted && (
                      <div className={classes.blacklistedContainer}>
                        <div className={classes.blacklistedTitle}>
                          <img src={blacklisted} alt="blacklisted customer" /> User Blacklisted
                        </div>
                        <CustomLink
                          roles={[USER_ROLES.IT_OPERATIONS, USER_ROLES.IT_OPERATIONS_LEADERSHIP, USER_ROLES.FINANCE]}
                          color="#0085FF"
                          onClick={removeModalOpen}
                        >
                          Remove
                        </CustomLink>
                      </div>
                    )}
                    <CustomButton
                      disabled={isBlacklisted}
                      size="lite"
                      text="Assign Bundle"
                      type="primary"
                      onClick={openModal}
                    />
                  </div>
                )}
              </div>
              <Divider />

              {data.inUse && (
                <div className={classes.bundleInUse}>
                  <div className={classnames(classes.sectionTitle, classes.inUseTitle)}>
                    <img src={circledPlayIcon} alt="in use" />
                    Bundle In Use
                  </div>
                  <div className={classnames(classes.bundleList, classes.bundleListInUse)}>
                    <div className={classnames(classes.dataItem, classes.inUseItem)}>
                      <div className={classes.leftContainer}>
                        <div className={classes.bundleName}>
                          {data.inUse?.name}
                          {data.inUse?.isPrimary && <img src={starIcon} alt="is Primary" />}
                        </div>

                        <div className={classes.section}>
                          <div className={classes.title}>Type</div>
                          <div className={classes.data} title={TYPES_MAP[data.inUse?.type]}>
                            {TYPES_MAP[data.inUse?.type]}
                          </div>
                        </div>
                        <div className={classes.section}>
                          <div className={classes.title}>
                            <img src={data.inUse?.type === "TB" ? time : cylinder} alt="cylinder" />
                          </div>
                          <div className={classes.data} title={data.inUse?.lpgOrTime}>
                            {data.inUse?.lpgOrTime}
                          </div>
                        </div>
                        <div className={classes.section}>
                          <div className={classes.title}>
                            <img src={price} alt="price" />
                          </div>
                          <div className={classes.data} title={data.inUse?.price}>
                            {data.inUse?.price}
                          </div>
                        </div>
                        <div className={classes.section}>
                          <div className={classes.title}>
                            <img src={duration} alt="duration" />
                          </div>
                          <div className={classes.data} title={data.inUse?.duration}>
                            {data.inUse?.validityPeriod}
                          </div>
                        </div>
                        <div className={classes.section}>
                          <div className={classes.title}>
                            <img src={timesheet} alt="timesheet" />
                          </div>
                          <div
                            className={classes.data}
                            title={`${data.inUse?.activationDate} / ${
                              data.inUse?.deactivationDate ? data.inUse?.deactivationDate : "-"
                            }`}
                          >
                            {`${data.inUse?.activationDate} / ${
                              data.inUse?.deactivationDate ? data.inUse?.deactivationDate : "-"
                            }`}
                          </div>
                        </div>
                      </div>

                      <div className={classes.actionsContainer}>
                        <NGIDropdownButton
                          position="left"
                          toggleEl={<img className={classes.imgBtn} src={menuIcon} alt="action-icon" />}
                          menuItems={
                            []
                            // [
                            //   {
                            //     label: "Set as Primary Bundle",
                            //     subLabel: "Will overwrite the previous primary one",
                            //     icon: starEmptyIcon,
                            //     callback: () => {},
                            //     roles: [
                            //       USER_ROLES.SYSTEM_FULL_ADMINS,
                            //       USER_ROLES.IT_OPERATIONS,
                            //       USER_ROLES.IT_OPERATIONS_LEADERSHIP,
                            //       USER_ROLES.CUSTOMER_CARE_LEADERSHIP,
                            //     ],
                            //   },
                            //   {
                            //     label: "Unassign Bundle",
                            //     subLabel: "Remove bundle from this group",
                            //     icon: removeIcon,
                            //     callback: () => {},
                            //     roles: [
                            //       USER_ROLES.SYSTEM_FULL_ADMINS,
                            //       USER_ROLES.IT_OPERATIONS,
                            //       USER_ROLES.IT_OPERATIONS_LEADERSHIP,
                            //     ],
                            //   },
                            //   {
                            //     label: "View Bundle",
                            //     subLabel: "View bundle detailed page",
                            //     icon: infoIcon,
                            //     callback: () => {
                            //       window.open(`/price-management/bundles/${data.inUse.id}`, "_blank");
                            //     },
                            //   },
                            // ]
                          }
                        />
                      </div>
                    </div>
                    <div className={classes.inUseSubData}>
                      <div className={classes.flex1}></div>
                      <div className={classes.section}>
                        <div className={classes.title}>Cooking Time</div>
                        <div className={classes.data}>{`${
                          data.inUse?.type === "TB"
                            ? consumptionStat.bundleRemainingDuration
                            : consumptionStat.bundleRemainingMassLimit
                        }/${data.inUse.lpgOrTime}`}</div>
                      </div>
                      <div className={classes.section}>
                        <div className={classes.title}>Expires in</div>
                        <div className={classes.data}>
                          {consumptionStat?.bundleExpiresAt
                            ? moment(consumptionStat?.bundleExpiresAt).diff(moment(), "days")
                            : 0}{" "}
                          days
                        </div>
                      </div>
                      <div className={classes.section}>
                        <div className={classes.title}>Activated</div>
                        <div className={classes.data}>
                          {consumptionStat?.bundleActivatedAt
                            ? customDateFormatWithTime(consumptionStat?.bundleActivatedAt)
                            : "-"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className={classnames(classes.availableBundles, isBlacklisted && classes.disabled)}>
                <div className={classes.sectionTitle}>Pending Bundle Assignments</div>
                {data.pendingList.length ? (
                  <div className={classes.bundleList}>
                    {data.pendingList?.map(item => (
                      <div key={item.id} className={classes.dataItem}>
                        <div className={classes.infoContainer}>
                          <div className={classes.name}>
                            {getName(item)}
                            {item.isPrimary && <img src={starIcon} alt="is Primary" />}
                            {statusFormatterWithMap(item?.status, STATUS_COLOR_MAP_ASSIGNMENTS, { marginLeft: 10 })}
                            {item.type === "Depot" && (
                              <Tooltip
                                key={item.id}
                                placement="bottom"
                                showArrow={false}
                                title={
                                  item.type === "Depot" && (
                                    <div className={classes.dataPreview}>
                                      <div className={classes.previewTitle}>Depot List</div>
                                      <ul className={classes.list}>
                                        {item?.depots?.map(key => (
                                          <li key={key}>{key}</li>
                                        ))}
                                      </ul>
                                    </div>
                                  )
                                }
                                color="#fff"
                              >
                                <span className={classes.depotsList}>
                                  Depots <span>{item.depots.length}</span>
                                </span>
                              </Tooltip>
                            )}
                          </div>
                        </div>
                        <div className={classes.category}>{textFormatter(item?.registrationCategory)}</div>

                        <div className={classes.dataContainer}>{`${item.activationDate} / ${
                          item.deactivationDate || "-"
                        }`}</div>
                        <div className={classes.pendingActionsContainer}>
                          <div className={classes.viewAll} onClick={() => openPreview(item)}>
                            VIEW ASSIGNMENT
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className={classes.noData}>No data is available</div>
                )}
              </div>

              <div className={classnames(classes.availableBundles, isBlacklisted && classes.disabled)}>
                <div className={classes.sectionTitle}>Available Bundles</div>
                {data.activeList.length ? (
                  <div className={classes.bundleList}>
                    {data.activeList?.map(item => (
                      <div key={item.id} className={classes.dataItem}>
                        <div className={classes.leftContainer}>
                          <div className={classes.bundleName}>
                            {item.bundleName}
                            {item.isPrimary && <img src={starIcon} alt="is Primary" />}
                          </div>

                          <div className={classes.section}>
                            <div className={classes.title}>Type</div>
                            <div className={classes.data} title={TYPES_MAP[item.bundleType]}>
                              {TYPES_MAP[item.bundleType]}
                            </div>
                          </div>
                          <div className={classes.section}>
                            <div className={classes.title}>
                              <img src={item.bundleType === "TB" ? time : cylinder} alt="cylinder" />
                            </div>
                            <div className={classes.data} title={item.lpgOrTime}>
                              {item.lpgOrTime}
                            </div>
                          </div>
                          <div className={classes.section}>
                            <div className={classes.title}>
                              <img src={price} alt="price" />
                            </div>
                            <div className={classes.data} title={item.price}>
                              {item.price}
                            </div>
                          </div>
                          <div className={classes.section}>
                            <div className={classes.title}>
                              <img src={duration} alt="duration" />
                            </div>
                            <div className={classes.data} title={item.duration}>
                              {item.validityPeriod}
                            </div>
                          </div>
                          <div className={classes.section}>
                            <div className={classes.title}>
                              <img src={timesheet} alt="timesheet" />
                            </div>
                            <div
                              className={classes.data}
                              title={`${item.activationDate} / ${item?.deactivationDate ? item.deactivationDate : "-"}`}
                            >
                              {`${item.activationDate} / ${item?.deactivationDate ? item.deactivationDate : "-"}`}
                            </div>
                          </div>
                        </div>

                        <div className={classes.actionsContainer}>
                          <NGIDropdownButton
                            position="left"
                            toggleEl={<img className={classes.imgBtn} src={menuIcon} alt="action-icon" />}
                            menuItems={[
                              ...(!item.isPrimary
                                ? [
                                    {
                                      label: "Set as Primary Bundle",
                                      subLabel: "Will overwrite the previous primary one",
                                      icon: starEmptyIcon,
                                      callback: () => {
                                        setSaveItem({
                                          id: item.id,
                                          type: BUNDLE_ASSIGNMENT_ACTIONS.SET_AS_PRIMARY,
                                        });
                                      },
                                      roles: [
                                        USER_ROLES.SYSTEM_FULL_ADMINS,
                                        USER_ROLES.IT_OPERATIONS,
                                        USER_ROLES.IT_OPERATIONS_LEADERSHIP,
                                        USER_ROLES.CUSTOMER_CARE_LEADERSHIP,
                                      ],
                                    },
                                  ]
                                : []),
                              {
                                label: "Unassign Bundle",
                                subLabel: "Remove bundle from this group",
                                icon: removeIcon,
                                callback: () => {
                                  setSaveItem({
                                    id: item.id,
                                    type: BUNDLE_ASSIGNMENT_ACTIONS.UN_ASSIGN,
                                  });
                                },
                                roles: [
                                  USER_ROLES.SYSTEM_FULL_ADMINS,
                                  USER_ROLES.IT_OPERATIONS,
                                  USER_ROLES.IT_OPERATIONS_LEADERSHIP,
                                ],
                              },
                              {
                                label: "View Bundle",
                                subLabel: "View bundle detailed page",
                                icon: infoIcon,
                                callback: () => {
                                  window.open(`/price-management/bundles/${item.bundleId}`, "_blank");
                                },
                              },
                            ]}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className={classes.noData}>No data is available</div>
                )}
              </div>
            </div>
          )}
          {activeTab === BUNDLE_TABS.PURCHASE_HISTORY && (
            <div>
              <div className={classes.actions}>
                <div className={classes.headerContainer}>
                  Bundle purchase history
                  <div>Full history of customer payments made for a bundle. </div>
                </div>
              </div>
              <Divider />

              <div className={classes.availableBundles}>
                {data.purchaseHistory.length ? (
                  <div className={classes.bundleList}>
                    {data.purchaseHistory?.map(item => (
                      <div key={item.id} className={classnames(classes.dataItem, classes.filled)}>
                        <div className={classes.leftContainer}>
                          <div className={classes.bundleName}>
                            <span className={classes.purchaseTime}>{customDateFormatWithTime(item.updatedAt)}</span>
                            {item.bundleDisplayName}
                          </div>

                          <div className={classes.section}>
                            <div className={classes.title}>Type</div>
                            <div className={classes.data} title={TYPES_MAP[item.bundleType]}>
                              {TYPES_MAP[item.bundleType]}
                            </div>
                          </div>
                          <div className={classes.section}>
                            <div className={classes.title}>
                              <img src={item.bundleType === "TB" ? time : cylinder} alt="cylinder" />
                            </div>
                            <div className={classes.data}>
                              {item.bundleType === "TB" ? item.cookingTime : item.gasLimit}
                            </div>
                          </div>
                          <div className={classes.section}>
                            <div className={classes.title}>
                              <img src={price} alt="price" />
                            </div>
                            <div className={classes.data} title={item.price}>
                              {item.price}
                            </div>
                          </div>
                          <div className={classes.section}>
                            <div className={classes.title}>
                              <img src={duration} alt="duration" />
                            </div>
                            <div className={classes.data} title={item.duration}>
                              {item.validityPeriod}
                            </div>
                          </div>
                          <div className={classes.section}>
                            <div className={classes.title}>
                              <img src={timesheet} alt="timesheet" />
                            </div>
                            <div
                              className={classes.data}
                              title={`${item.activationDate} / ${item?.deactivationDate ? item.deactivationDate : "-"}`}
                            >
                              {`${item.activationDate} / ${item?.deactivationDate ? item.deactivationDate : "-"}`}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className={classes.noData}>No data is available</div>
                )}
              </div>
            </div>
          )}
          {activeTab === BUNDLE_TABS.PRIMARY_HISTORY && (
            <div>
              <div className={classes.actions}>
                <div className={classes.headerContainer}>
                  Primary bundles history
                  <div>Log for assigning and unsinging of primary bundles</div>
                </div>
              </div>
              <Divider />

              <div className={classes.availableBundles}>
                {data.primaryHistory.length ? (
                  <div className={classes.bundleList}>
                    {data.primaryHistory?.map(item => (
                      <div key={item.bundleAssignmentId} className={classes.item}>
                        <div className={classes.purchaseName}>
                          <div
                            className={classnames(classes.iconContainer, classes[item?.action?.replace(/\s+/g, "")])}
                          >
                            <img src={ICONS_MAP[item?.action]} alt={item?.action} />
                          </div>
                          <Popover
                            content={getContent(item)}
                            placement="bottom"
                            title={<div>{item.bundleDisplayName}</div>}
                          >
                            <Link className={classes.link}>{item?.bundleDisplayName}</Link>
                          </Popover>{" "}
                          {` ${item?.action}`}
                          <span>{` by `}</span> {item?.updatedBy}
                        </div>
                        <div className={classes.date}>{customDateFormatWithTime(item?.updatedAt)}</div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className={classes.noData}>No data is available</div>
                )}
              </div>
            </div>
          )}
        </div>
        {!!saveItem && (
          <ConfirmationModal
            description={`Are you sure you want to ${saveItem.type}?`}
            onCancel={closeConfirmationModal}
            onConfirm={onConfirm}
          />
        )}
        {showAssignBundle && <AssignBundleModal onClose={closeModal} update={getData} customerId={customer.id} />}
        {!!previewData && <ReviewAssignmentModal onClose={closePreview} hideActions item={previewData} />}
        {removeConfirmation && (
          <ConfirmationModal
            title="Confirmation Removal"
            description="Are you sure you want to do remove this customer from blacklist?"
            reasons={blacklistRemovingReason}
            onConfirm={handleRemove}
            cancelBtnTitle="Cancel"
            confirmBtnTitle="Confirm"
            onCancel={removeModalClose}
            reasonTitle="Reason for Removing*"
            commentTitle="Additional Comment"
            isReasonRequired
            withComment
          />
        )}
      </Spin>
    </div>
  );
};

export default BundlesTab;
